import { CancelRounded, CheckCircleRounded, Swipe } from "@mui/icons-material";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Switch,
  Box,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Fragment } from "react";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({
  tableContainer: {
    width: "100%",
    borderRadius: 16,
    border: `1px solid ${theme.palette.divider}`,
  },
  tableRow: {
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
    cursor: "pointer",
    "&:last-child": {
      "& td": {
        borderBottom: "none",
      },
    },
  },
  tableCell: {
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
}));

function Results({ roles, isEditing, handleEdit }) {
  const { classes } = useStyles();
  const theme = useTheme();
  const permissionObj = roles[0]?.permissions;

  return (
    <TableContainer className={classes.tableContainer}>
      <Table>
        <TableHead sx={{ backgroundColor: theme.palette.background.light }}>
          <TableRow>
            <TableCell className={classes.tableCell}>Features / Capabilities</TableCell>
            {roles.map((role) => (
              <TableCell key={role.id} className={classes.tableCell} style={{ minWidth: 100 }}>
                {role.role}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {Object.keys(permissionObj).map((permission) => (
            <TableRow key={permission} className={classes.tableRow}>
              <TableCell className={classes.tableCell}>
                {permissionObj[permission].label}
              </TableCell>
              {roles.map((role) => (
                <TableCell
                  key={role.id}
                  className={classes.tableCell}
                  style={{ minWidth: 100 }}>
                  {isEditing ? (
                    <Switch
                      size="small"
                      checked={role.permissions[permission].value}
                      onChange={(e) => {
                        handleEdit(role.id, permission, e.target.checked);
                      }}
                    />
                  ) : (
                    <Box display="flex" alignItems="center">
                      {role.permissions[permission].value ? (
                        <CheckCircleRounded color="success" />
                      ) : (
                        <CancelRounded color="error" />
                      )}
                    </Box>
                  )}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default Results;
